/* eslint-disable no-redeclare */
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Address as AddressRetail } from '@msdyn365-commerce/retail-proxy';
import * as React from 'react';
import { IDeliveryType } from './utilities';

export type addressType = 'store' | 'ship';

export interface IShippingAddressProps {
    moduleName: string;
    address: AddressRetail;
    deliveryType: IDeliveryType;
    resource: {
        shipToLabel: string;
        storeLabel: string;
        phoneLabel: string;
        phoneAriaLabel: string;
    };
}

const Address: React.SFC<IShippingAddressProps> = ({
    moduleName,
    address,
    deliveryType,
    resource: { shipToLabel, storeLabel, phoneLabel, phoneAriaLabel }
}) => (
    <div className={`${moduleName}__address deliveryType-${deliveryType}`}>
        <div className={`${moduleName}__address-header`}>{deliveryType === 'pickUp' ? storeLabel : shipToLabel}</div>
        {address.Name && <span className={`${moduleName}__address-name`}>{address.Name}</span>}
        {address.FullAddress && <span className={`${moduleName}__address-full-address`}>{address.FullAddress}</span>}

        {/* TODO: Address format is based on country format
         {address.Name && <span className={`${moduleName}__address-name`}>{address.Name}</span>}
        {address.Street && <span className={`${moduleName}__address-street`}>{address.Street} </span>}
        {address.City && <span className={`${moduleName}__address-city`}>{address.City}</span>}
        {address.State && <span className={`${moduleName}__address-state`}>{`, ${address.State}`}</span>}
        {address.ZipCode && <span className={`${moduleName}__address-zipcode`}>{` ${address.ZipCode}`}</span>}
        {address.Phone && (
            <span className={`${moduleName}__address-phone`}>{phoneLabel}
                <a className={`${moduleName}__address-phone-number`} href={`tel:${address.Phone}`} aria-label={phoneAriaLabel}>
                    {address.Phone}
                </a>
            </span>
        )} */}
    </div>
);

export default React.memo(Address);
